// extracted by mini-css-extract-plugin
export default {"number":"accounts_number__eMJic","header":"accounts_header__5wl8C"};